import { Component } from '@angular/core';
import { soundpostAgreementTypeEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';
import {  } from "@memberjunction/ng-entity-viewer"

@RegisterClass(BaseFormComponent, 'Agreement Types') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-soundpostagreementtype-form',
    templateUrl: './soundpostagreementtype.form.component.html'
})
export class soundpostAgreementTypeFormComponent extends BaseFormComponent {
    public record!: soundpostAgreementTypeEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true },
            { sectionKey: 'agreements', sectionName: 'Agreements', isExpanded: false }
        ]);
    }
}

